$(document).ready(function() {
    // Init Dropotron
    $('#main-navigation > ul').dropotron({ 
      hideDelay: 550,
      mode: 'slide',
      easing: 'swing', // Easing mode ("swing", "linear")
    });

    // Home button video launch
    $(document).ready(function() {
      $('.video-button-home').magnificPopup({type:'iframe'});
    });

    // Menu accordions
    $("#menu-main-navigation").navgoco({accordion: true});
    $("#menu-main-navigation-2").navgoco({accordion: true});

    // // Animate mobile trigger icon
    // $('.mobile-nav-trigger').on('click', function(){
    //     $('.menu-icon').toggleClass('is-clicked'); 
    // }); 

    // Slick slider
    $('.ckd-slider').slick({
      adaptiveHeight: true,
      autoplay: false,
      arrows: true,
      dots: true,
    });

    // Slick slider
    $('.responsive-carousel').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 1001,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 681,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });

    // Navgoco accordions (plays well with touch screens)
     $('.accordions').navgoco({
          accordion: false, // true = one open at a time, false = open many at the same time
          openClass: 'open',
          slide: {
              duration: 500,
              easing: 'swing'
          }
    });

    // Zozo Tabs
    $(".tabbed").zozoTabs({
      theme: 'white',
      spaced: false,
      style: 'normal',
      position: 'top-compact',
      bordered: false,
      responsive: true,
      responsiveDelay: 0,
      minWindowWidth: 681,
      mobileNav: true,
      rounded: false,
      size: 'small', 
      multiline: false,
      animation: {
          type: 'css',
          duration: 600,
          effects: 'fade'
      }
    });

    // Zozo Tabs on share price info page
    $("#share-price-tabs").zozoTabs({
      theme: 'white',
      spaced: false,
      style: 'normal',
      position: 'top-compact',
      bordered: false,
      responsive: true,
      responsiveDelay: 0,
      minWindowWidth: 1001,
      mobileNav: true,
      rounded: true,
      size: 'medium', 
      multiline: false,
      shadows: false,
      animation: {
          type: 'css',
          duration: 600,
          effects: 'fade'
      }
    });

    // Zozo Accordions
    $(".accordion").zozoAccordion({
        theme: "gold",
        active: 0,
        sectionSpacing: 4,
        animation: {
            duration: 300,
            easing: "swing",
        }
    });

    $(function() {
        $('.match-height').matchHeight();
        $('.quick-link').matchHeight();
        $('.individual-quick-link').matchHeight();
        $('.quick-links-home .individual-quick-link h3').matchHeight();
        $('.investors-block h3').matchHeight();
    });

    // Read More links on Board of Directors page
    var maxChars = 350;
      var ellipsis = "...";
      $(".single-person").each(function() {
          var text = $(this).find(".text.full").text();
          var html = $(this).find(".text.full").html();        
          if(text.length > maxChars)
          {            
              var shortHtml = html.substring(0, maxChars - 3) + "<span class='ellipsis'>" + ellipsis + "</span>";
              $(this).find(".text.short").html(shortHtml);            
          }
      });
      $(".bio-read-more").click(function(){        
          var readMoreText = "Read more...";
          var readLessText = "Read less...";        
          var $shortElem = $(this).parent().find(".text.short");
          var $fullElem = $(this).parent().find(".text.full");        
          
          if($shortElem.is(":visible"))
          {           
              $shortElem.stop().hide();
              $fullElem.stop().fadeIn(250);
              $(this).text(readLessText);
          }
          else
          {
            $fullElem.stop().hide();
            $shortElem.stop().fadeIn(250);
            $(this).text(readMoreText);
          }       
      });

      // Products & Technologies tabs
      $(".hashtabs").hashTabs({
        smoothScroll: {
          initialTabIndex: null,
          enabled: true,
          history: false,
          initialTabId: "dummy"        
        }
      });

      // Back button
      $('a.back').click(function(){
          parent.history.back();
          return false;
      });

      // Show or hide older reports on financial reports page
      $(".older-reports-link").click(function(){
        $(".older-reports").fadeToggle('slow','swing');
        $(".older-reports-link").toggleClass( "visible" );
      });

      // Add support for placeholders in input fields for older browsers
      $('input, textarea').placeholder();

      // Add responsive helper class to tables
      $('table').addClass('data');

      // Made sure all 'thead td's are made into 'th's to use for responsive tables
      $('thead tr td').each(function() {
          $(this).replaceWith("<th>" + $(this).html() + "</th>");
      });

      // Responsive tables http://codepen.io/Holger0/pen/imavf
      $('th').each(function(i) {
        var cell = 'td:nth-child(' + (i+1) + ')';
        var head = 'th:nth-child(' + (i+1) + ')';
        var headtxt = $(head).text();
        $(cell).attr('data-heading', headtxt);
      });

      // Smooth scroll anchor links
      $('a[href*=#]:not([href=#])').click(function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
              || location.hostname == this.hostname) {

              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                 if (target.length) {
                   $('html,body').animate({
                       scrollTop: target.offset().top
                  }, 1000);
                  return false;
              }
          }
      });

      // Dropdown/accordion to filter news lists
      $('.category-dropdown').click(function(){
          $(this).children('.sub-categories').toggleClass('active');
          $(this).toggleClass('active');
      });

      // Replace icon font on hover
      $(function(){
      var prev;    

      $('.related-news-item').hover(function(){
      prev = $(this).find(".related-arrow").text();
        $(this).find(".related-arrow").text("N");
      }, function(){
        $(this).find(".related-arrow").text(prev)
      });
      })

      // Dont allow form submit unless agree checkbox is checked
      $('.sign-up__agree-checkbox').click(function() {
        if ($(this).is(":checked")) {
            $(".pre-footer .button").removeAttr("disabled");
        } else {
            $(".pre-footer .button").attr("disabled", "disabled");
        }
      });
});

// ==========================================================================
//  Redirect all users who haven't agreed to disclaimer
// ==========================================================================
function gatedCheck() {
  if (document.body.classList.contains('page-template-gated')) {
    if (localStorage.getItem('gateAgree') === 'declined') {
      window.location = '/'
    } else if(localStorage.getItem('gateAgree') === 'accept') {
      const content = document.querySelector('.body-content.gated')

      content.classList.remove('gated')
    } else {
      window.location = '/gated-content-disclaimer/'
    }
  }
}

gatedCheck()

// ==========================================================================
//  Check for country when proceeding
// ==========================================================================
function gatedDisclaimer() {
  const proceedButton = document.querySelector('.gate-disclaimer button')
  const countryOfResidenceSelect = document.querySelector('.country-of-residence select')
  const countryAccessingSelect = document.querySelector('.accessing-country select')

  if (proceedButton) {
    const disallowedCoutries = ['none', 'United States of America', 'Guam', 'Northern Mariana Islands', 'Puerto Rico', 'Virgin Islands (USA)', 'Australia', 'Canada', 'Japan', 'South Africa']

    proceedButton.addEventListener("click", () => {
      
      if (countryOfResidenceSelect.value === 'none' || countryAccessingSelect === 'none') {
        alert('Please select a country')
      }
      
      if (disallowedCoutries.includes(countryOfResidenceSelect.value) || disallowedCoutries.includes(countryAccessingSelect.value)) {
        window.location = '/gated-content-restricted/'
      } else {
        window.location = '/gated-content-notice/'
      }
    })
  }
}

gatedDisclaimer()

// ==========================================================================
//  Watch for agree/disagree on gated notice
// ==========================================================================
function gatedNotice() {
  if (document.body.classList.contains('page-template-gated-notice')) {

    // If a user has already declined, don't let them revisit this page
    if (localStorage.getItem('gateAgree') === 'declined') {
      window.location = '/'
    } else {
      const doNotAgreeCheckBox = document.querySelector('.container-checkbox.do-not-agree')
      const agreeCheckBox = document.querySelector('.container-checkbox.agree')

      if (doNotAgreeCheckBox) {
        doNotAgreeCheckBox.addEventListener("click", event => {
          localStorage.setItem('gateAgree', 'declined');
          window.location = '/'
        })
      }

      if (agreeCheckBox) {
        agreeCheckBox.addEventListener("click", event => {
          localStorage.setItem('gateAgree', 'accept');
          window.location = '/investors/2020-fundraise/'
        })
      }
    }
  }
}

gatedNotice()